export const DEFAULT_IMAGES_URL =
  'https://tenecesito-bucket.s3-us-west-1.amazonaws.com/profile-images/media/default_images';
